import React, { Fragment } from "react";
import { noop, get, has } from "lodash";
import Parser from "html-react-parser";
import DOMPurify from "dompurify";

import HeaderRegistration from "../../_organism/HeaderRegistration";
import {
  OuterContainer,
  InnerContainer,
  InnerTitle,
  InnerInfo,
  MobilePageWrapper,
  DisclaimerWrapper,
  DisclaimerText,
  LegalContentButton,
  ReviewSubmitButton
} from "./styled-components";
import { PerimeterxContainer, RobotMessage } from "../Login/styled-components";
import { fontMedium } from "../../_static/Typography";
import EditDetails from "../../_molecule/EditDetails";
import { lock } from "../../_static/Icons/icons";
import buildColor from "../../_static/ColorPalette";
import Icon from "../../_static/Icons";

export const parseLegalContent = ({
  handleLegalContentButton,
  setLegalContentOrigin,
  legalContent
}) => {
  // CAPI HTML string content is sanitized to prevent potential XSS
  const sanitizedContent = DOMPurify.sanitize(legalContent);
  const options = {
    replace: (domNode) => {
      const buttonContentType = get(domNode, "attribs.id");

      if (domNode.name === "button" && buttonContentType) {
        return (
          <LegalContentButton
            qaLabel={`legal-content-button-${buttonContentType}`}
            onClick={() => {
              setLegalContentOrigin(buttonContentType);
              handleLegalContentButton({
                isOpen: true,
                contentType: buttonContentType
              });
            }}
          >
            {domNode.children[0].data}
          </LegalContentButton>
        );
      }
      return domNode;
    }
  };
  return (
    <DisclaimerText data-qa-label="review-legal-text">
      {Parser(sanitizedContent, options)}
    </DisclaimerText>
  );
};

const ReviewPageRegistrationTemplate = ({
  device,
  brand,
  infoText,
  innerTitle,
  handleBackButton,
  handleLegalContentButton,
  setLegalContentOrigin,
  currentStep,
  groups,
  handleSubmitRegistrationButton,
  isLoading,
  passwordText,
  gamblingProblem,
  legalContent,
  stateNotes,
  userHomeState,
  isHumanChallengeEnabled,
  robotMessage
}) => (
  <OuterContainer data-qa-label="review-outer-container">
    <HeaderRegistration
      device={device}
      brand={brand}
      currentStep={currentStep}
      handleBackButton={handleBackButton}
      innerTitle={innerTitle}
    />

    <InnerContainer>
      <MobilePageWrapper>
        {(innerTitle || infoText) && (
          <Fragment>
            <InnerTitle data-qa-label="welcome-inner-title">
              {innerTitle}
            </InnerTitle>
            <InnerInfo data-qa-label="welcome-inner-info-mobile">
              {infoText}
            </InnerInfo>
          </Fragment>
        )}
      </MobilePageWrapper>

      {groups.map(
        ({
          hasBorderBottom = true,
          hasBorderTop = false,
          wrapperOnClick = noop,
          wrapperMarginBottom = 12,
          rows = []
        }) => (
          <EditDetails
            hasBorderBottom={hasBorderBottom}
            hasBorderTop={hasBorderTop}
            wrapperMarginBottom={wrapperMarginBottom}
            wrapperOnClick={wrapperOnClick}
            rows={rows}
            key={rows[0].qaLabel}
            data-qa-label={`review-details-section-${get(
              rows[0],
              "qaLabel",
              ""
            )}`}
          />
        )
      )}

      {isHumanChallengeEnabled && <RobotMessage>{robotMessage}</RobotMessage>}
      <PerimeterxContainer id="pxElement" />
      {!isHumanChallengeEnabled && (
        <ReviewSubmitButton
          size="bigger"
          type="bet"
          hasRoundedCorners
          isStretched
          isUppercase={false}
          hasShadow
          fontFamily={fontMedium}
          isBold={false}
          qaLabel="registration-submit-btn"
          onClick={handleSubmitRegistrationButton}
          isLoading={isLoading}
          showDisabled={isLoading}
          loadingBackgroundColor={buildColor("white", "100")}
          loadingBorderColor={buildColor("white", "30")}
        >
          Finish Registration
        </ReviewSubmitButton>
      )}

      <DisclaimerWrapper data-qa-label="review-disclaimer-section">
        {passwordText && (
          <DisclaimerText data-qa-label="review-password-text">
            <Icon
              qaLabel="review-password-icon"
              icon={lock}
              size={16}
              color={buildColor("grey", "800")}
            />
            {passwordText}
          </DisclaimerText>
        )}
        {legalContent &&
          parseLegalContent({
            handleLegalContentButton,
            setLegalContentOrigin,
            legalContent
          })}
        {userHomeState &&
          stateNotes &&
          has(stateNotes, userHomeState) &&
          stateNotes[userHomeState].map((note) => (
            <DisclaimerText data-qa-label="review-state-notes">
              {note}
            </DisclaimerText>
          ))}
        {gamblingProblem && (
          <DisclaimerText data-qa-label="review-gambling-problem-text">
            {gamblingProblem}
          </DisclaimerText>
        )}
      </DisclaimerWrapper>
    </InnerContainer>
  </OuterContainer>
);

ReviewPageRegistrationTemplate.defaultProps = {
  device: "mobile",
  brand: "tvg",
  innerTitle: "",
  infoText: "",
  handleBackButton: noop,
  handlePrivacyPolicy: noop,
  handleTermsConditions: noop,
  currentStep: "WELCOME",
  groups: [],
  isHumanChallengeEnabled: false,
  robotMessage: ""
};

export default ReviewPageRegistrationTemplate;
